export default __webpack_public_path__ + "static/force-usa-_small-image_1-4228a17d5b63a165a10f9ed1f596463d.webp";